import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Shop.css';
import products from './products';
import PageNavigation from './PageNavigation';

function Shop() {
    const [displayText, setDisplayText] = useState('');
    const [showCursor, setShowCursor] = useState(true);
    const [animationPhase, setAnimationPhase] = useState('blinking');
    const [, setBlinkCount] = useState(0);

    const text1 = "H4NDKR4FT3D P4RTI3$";
    const text2 = "[FØR 4 N3W WØRLD]";

    useEffect(() => {
        let interval;

        if (animationPhase === 'blinking') {
            interval = setInterval(() => {
                setShowCursor(prev => !prev);
                setBlinkCount(prev => {
                    if (prev >= 5) {
                        setAnimationPhase('typing');
                        return 0;
                    }
                    return prev + 1;
                });
            }, 500);
        } else if (animationPhase === 'typing') {
            setShowCursor(true);
            let currentIndex = 0;
            const fullText = text1 + '\n' + text2 + '\n';

            interval = setInterval(() => {
                if (currentIndex < fullText.length) {
                    setDisplayText(fullText.substring(0, currentIndex + 1));
                    currentIndex++;
                } else {
                    clearInterval(interval);
                    setShowCursor(false);
                    setAnimationPhase('complete');
                }
            }, 100);
        }

        return () => clearInterval(interval);
    }, [animationPhase]);

    return (
        <div className="shop-page">
            <PageNavigation />
            {/* Video Background */}
            <div className="video-container">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="background-video"
                >
                    <source src="/rotb_big.mp4" type="video/mp4" />
                </video>
                <div className="video-overlay"></div>
            </div>

            {/* Products Grid */}
            <div className="products-container">
                <header className="collection-heading"><p>ROTB / CLOTHES</p><h1>NEW COLLECTION</h1><span>Freestyler €45 · Asher €48 · Hoodie €69</span>
                    <p className="collection-fabric">100% organic heavyweight cotton tees</p>
                    <span>Freestyler: 240 GSM, relaxed fit<br />Asher: 280 GSM, oversized boxy fit</span>
                </header>
                <div className="products-grid">
                    {products.map((product) => (
                        <Link
                            key={product.id}
                            className="shop-product-card"
                            to={`/product/${product.id}`}
                        >
                            <div className="shop-product-image-container">
                                <img
                                    src={product.image}
                                    alt={product.name}
                                    className="shop-product-image"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <div className="shop-product-info">
                                <h3 className="shop-product-name">{product.name}</h3>
                                <p className="shop-product-type">{product.variants ? 'Freestyler / Asher' : product.type}</p>
                                <p className="shop-product-price">{product.variants ? '€45 / €48' : product.price}</p>
                                <span className="shop-details-btn">VIEW DETAILS →</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            {/* Typing Animation */}
            <div className="shop-typing-container">
                <div className="typing-text">
                    {displayText.split('\n').map((line, index) => (
                        <div key={index} className="typing-line">
                            {index === 1 && line.includes('[') ? (
                                <>
                                    {line.charAt(0) === '[' && <span className="bracket">[</span>}
                                    {line.length > 2 && <span className="bracket-text">{line.slice(1, -1)}</span>}
                                    {line.charAt(line.length - 1) === ']' && <span className="bracket">]</span>}
                                </>
                            ) : (
                                line
                            )}
                            {index === displayText.split('\n').length - 1 && showCursor && <span className="cursor">|</span>}
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}

export default Shop;
